import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import { Button } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";

const CalendarsPage = () => {
    const tasks = [
        {
            title: 'Event 1',
            start: '2024-03-03',
            end: '2024-03-08',
            color: '#032d4d' // Specify the color for Event 1
          },
          {
            title: 'Event 2',
            start: '2024-03-15',
            end: '2024-03-17',
            color: '#000' // Specify the color for Event 2
          },
          {
            title: 'Event 3',
            start: '2024-03-25',
            end: '2024-03-28',
            color: '#032d4d' // Specify the color for Event 2
          },
        // Add more tasks as needed
      ];

    return (
        <>
            <PageHeader name="Calendars" />
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    <div className="col-auto p-0 d-flex">

                                    </div>
                                    {/* <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line" />
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="card-body">
                                <FullCalendar
                                    defaultView="dayGridMonth"
                                    header={{
                                        left: "prev,next",
                                        center: "title",
                                        right: "dayGridMonth,timeGridWeek,timeGridDay"
                                    }}
                                    plugins={[dayGridPlugin]}
                                    events={tasks}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CalendarsPage;